import * as activityView from '../services/activityView';

export default {
  namespace: 'activityView',

  state: {
    viewList: [],
  },

  effects: {
    *getViewList({ payload: { values } }, { call, put }) {
      const response = yield call(activityView.getViewList, values);
      yield put({
        type: 'save',
        payload: {
          viewList: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
